export default "__VITE_PUBLIC_ASSET__d3f1c2a3__"